// extracted by mini-css-extract-plugin
export default {"Weather_current_container":"CurrentWeather_Weather_current_container__do7P-","Current_icon":"CurrentWeather_Current_icon__n6xLk","Current_temp":"CurrentWeather_Current_temp__UsdWg"};